module.exports = __webpack_public_path__ + "img/4.58afa902.jpg";